import React, {useState, useEffect} from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import InputMasked from "react-input-mask";

import api from "../../../service/api";

import Header from "../../../components/Header";
import NavTabs from "../../../components/NavTabs";
import ModalShare from "../../../components/ModalShare";
import Input from "../../../components/Input";
import Button from "../../../components/Button";
import ErrorMessage from "../../../components/ErrorMessage";

import { Legend, Label, ContainerSubText, SubText, ButtonContainer, FormContainer } from "./styles";

import routes from "../../../routes/orderPay.routes";
import Main from "../../../components/Main/index";

//Help Functions
import { openModal } from "../../../helpers/modalFunctions";

//Assets
import search from "../../../assets/icons/search.svg";

import { ToastContainer } from "react-toastify";

// Utils
import { toastCreate, toastUpdate } from "../../../utils/notifications/toast";
import { notifysFieldsForm } from "../../../utils/notifications/notifyForm";
import convertAmountInCents from "../../../utils/amountInCents";

const PayOrderComplete = () => {
    const [client, setClient] = useState({
        id: "",
        buyerIdAdquirente: "",
        firstName: "",
        lastName: "",
        phoneNumber: "",
        email: ""
    });
    const [debouncedClientName, setDebouncedClientName] = useState("");
    const [clientsSearchResult, setClientsSearchResult] = useState([]);
    
    const [branchConfig, setBranchConfig] = useState({
        multa: 0,
        juros: 0,
        instructions: ""
    });

    const [errorOnSubmit, setErrorOnSubmit] = useState(false);
    const [errorInReturnApi, setErrorInReturnApi] = useState(false);

    const [payOrderInfo, setPayOrderInfo] = useState({
        id: null,
        url: "",
        amount: 0,
        description: "",
        establishment: ""
    });

    const [message, setMessage] = useState("");

    const login = useSelector((state: {login: any}) => state.login);
    const history = useHistory();
    
    useEffect(() => {
        if(login.user.groups.mc4a2 === false){
            history.push("/admin/dashboard");
        }
    }, []);

    useEffect(() => {
        const getConfigAtApi = async () => {
            const {data} = await api.get(`/adm/ownerbranch/list?id=${login.user.branchsId}&configuration=true`);
            
            setBranchConfig(data.Configurations);
        }

        getConfigAtApi();
    }, []);

    useEffect(() => {
        const timerId = setTimeout(() => {
            setDebouncedClientName(client.firstName)
        }, 300);
        
        return () => {
            clearTimeout(timerId);
        }
    }, [client.firstName]);
  
    useEffect(() => {
        const getBuyersAtApi = async () => {
            const {data} = await api.get("/buyer/list", {
                params: {
                    branchsId: login.user.branchsId,
                    search: debouncedClientName
                }
            });
            
            setClientsSearchResult(data.Buyer)
        }
        
        if(debouncedClientName !== ""){
            getBuyersAtApi();
        }
    }, [debouncedClientName]);

    const formValidationWithYup = Yup.object().shape({
        value: Yup.string().required(),
        description: Yup.string().required(),
        dueDate: Yup.string().required(),
        instructions: Yup.string().required(),
    })

    const searchForErrors = (errors: Object) => {
        if(errors !== {}){
          setErrorOnSubmit(true)
        } else {
          setErrorOnSubmit(false)
        }
    }

    const sendEmail = async () => {
        try {
            const { data } = await api.post("/boletos/send/email", {
                id: payOrderInfo.id,
                email: client.email,
                link: payOrderInfo.url,
                buyer_name: `${client.firstName} ${client.lastName}`,
                establishment: login.user.branchs.businessName
            });
    
            setMessage("Email enviado com sucesso");
        } catch (error) {
            setMessage("Falha ao enviar email")
        }
    }

    const sendWhatsapp = async () => {
        try {
            const {data} = await api.post("/linkpay/send/whats", {
                link: payOrderInfo.url,
                phoneSms: `55${client.phoneNumber}`,
                amount: payOrderInfo.amount,
                description: payOrderInfo.description,
                establishment: payOrderInfo.establishment
            });
    
            setMessage("Mensagem enviada com sucesso");
        } catch (error) {
            setMessage("Falha ao enviar mensagem")
        }
    }

    return(
        <Main>
            <ToastContainer />
            <Header title="Boleto" subTitle="Gere pagamentos via boleto bancário de forma fácil e rápida." subTitleWidth={236}/>
            <NavTabs tabs={routes}/>
            <ModalShare 
                text="Boleto gerado com sucesso"
                type={1}
                sendEmail={sendEmail}
                sendWhatsapp={sendWhatsapp}
                // sendSms={sendSms}
                linkExternal={payOrderInfo.url}
                message={message}
            />

            <Formik
                initialValues={{
                    value: "",
                    description: "",
                    dueDate: "",
                    instructions: ""
                }}
                validationSchema={formValidationWithYup}
                onSubmit={async (values) => {
                    const amountInCents = convertAmountInCents(values.value)

                    let dueDate: Array<string> | string = values.dueDate.split("/");
                    
                    dueDate = `${dueDate[2]}-${dueDate[1]}-${dueDate[0]}`;

                    const buyerIdAdquirente = client.buyerIdAdquirente.split("-").join("");

                    try {
                        const response = await api.post("/boletos/create", {
                            "branchsId": login.user.branchsId,
                            "buyersId": client.id,
                            "buyerIdAdquirente": buyerIdAdquirente,
                            "sellerOwnerPayId": login.user.branchs.sellerOwnerPayId,
                            "apiOwnerId": login.user.powerUser === true ? "ZOOP" : login.user.branchs.apiOwner.description,
                            "amount": Math.round(amountInCents),
                            "description": values.description,
                            "expiration_date": dueDate,
                            "payment_limit_date": dueDate,
                            "body_instructions": values.instructions,
                            "establishment": login.user.branchs.businessDescription,
                            "standardLogo": login.user.branchs.standardLogo === null ? "" : login.user.branchs.standardLogo,
                        });

                        // const linkShort = await api.get(`/link`, {
                        //     params: {
                        //         link: response.data.url
                        //     }
                        // });

                        setPayOrderInfo({
                            id: response.data.id,
                            url: response.data.url,
                            amount: Math.round(amountInCents),
                            description: values.description,
                            establishment: login.user.branchs.businessDescription
                        });
                        setErrorInReturnApi(false);
                        setMessage("");
                        openModal("exampleModal");
                        toastUpdate("btnSubmit","success",2000,"Sucesso" )
                        window.open(`${response.data.url}`);
                    } catch (e) {
                        setErrorInReturnApi(true);
                        toastUpdate("btnSubmit","error",4000, "Ocorreu um problema, entre em contato com o suporte." )
                    }
                }}
            >
                {({handleChange, errors, handleSubmit, initialValues}) => {
                    initialValues.instructions = branchConfig.instructions !== null ? branchConfig.instructions : "";
                    
                    return(
                        <>
                            <div className="row">
                                <FormContainer className="mr-5">
                                {/* className="col-12 col-md-6 col-lg-4" */}
                                    <fieldset>
                                        <Legend>Dados do boleto</Legend>
                                        <Form id="form-pay-order" autoComplete="off">
                                            <div className="inputWithIcon" aria-autocomplete="none">
                                                <Input 
                                                    id="clientName" 
                                                    name="clientName"
                                                    className="inputCustom"
                                                    type="search"
                                                    autoComplete="off"
                                                    style={{borderColor: `${errorOnSubmit && client.buyerIdAdquirente === "" ? "red" : "rgba(194, 194, 194, 0.2)"}`}} 
                                                    placeholder="Cliente"
                                                    isSearchField={true}
                                                    searchResults={clientsSearchResult}
                                                    searchType="name"
                                                    value={client.firstName}
                                                    setValue={setClient}
                                                    onChange={(e: any) => {
                                                        setClient({
                                                            id: client.id, 
                                                            buyerIdAdquirente: client.buyerIdAdquirente,
                                                            firstName: e.target.value,
                                                            lastName: client.lastName,
                                                            phoneNumber: client.phoneNumber,
                                                            email: client.email
                                                        });
                                                    }}
                                                />
                                                <img src={search}/>
                                            </div>
                                            <Field 
                                                id="value" 
                                                name="value" 
                                                className="inputCustom" 
                                                type="text"
                                                style={{borderColor: `${errorOnSubmit && errors.value ? "red" : "rgba(194, 194, 194, 0.2)"}`}} 
                                                placeholder="Valor do boleto" 
                                                as={Input}
                                            />
                                            <Field 
                                                id="description" 
                                                name="description" 
                                                className="inputCustom" 
                                                style={{borderColor: `${errorOnSubmit && errors.description ? "red" : "rgba(194, 194, 194, 0.2)"}`}} 
                                                placeholder="Descrição do boleto" 
                                                as={Input}
                                            />
                                        </Form>
                                    </fieldset>

                                </FormContainer>

                                <FormContainer>
                                    <fieldset>
                                        <Legend>Configuração do boleto</Legend>
                                        <Form>
                                            <div>
                                                <Field 
                                                    name="dueDate" 
                                                    
                                                    >
                                                    {() => (
                                                        <InputMasked
                                                            id="dueDate" 
                                                            placeholder="Data Vencimento"
                                                            className="input-masked" 
                                                            style={{borderColor: `${errorOnSubmit && errors.dueDate ? "red" : "rgba(194, 194, 194, 0.2)"}`}} 
                                                            mask="99/99/9999"
                                                            onChange={handleChange}
                                                            type="tel"
                                                        />
                                                    )}
                                                </Field>
                                                <ContainerSubText>
                                                    <SubText>*Data não pode exceder 30 dias</SubText>
                                                </ContainerSubText>
                                            </div>
                                            <div className="row">
                                                <div className="col-6 col-lg-4">
                                                    <Label>Multa%</Label>
                                                    <Field 
                                                        id="penalty" 
                                                        name="penalty" 
                                                        className="inputCustom" 
                                                        // style={{borderColor: `${errorOnSubmit && errors.penalty ? "red" : "rgba(194, 194, 194, 0.2)"}`}} 
                                                        value={branchConfig.multa !== null ? branchConfig.multa : 0}
                                                        onChange={handleChange} 
                                                        disabled 
                                                        as={Input}
                                                    />
                                                </div>

                                                <div className="col-6 col-lg-4">
                                                    <Label>Juros%</Label>
                                                    <Field 
                                                        id="fee" 
                                                        name="fee" 
                                                        className="inputCustom" 
                                                        // style={{borderColor: `${errorOnSubmit && errors.fee ? "red" : "rgba(194, 194, 194, 0.2)"}`}} 
                                                        value={branchConfig.juros !== null ? branchConfig.juros : 0}
                                                        onChange={handleChange} 
                                                        disabled 
                                                        as={Input}
                                                    />
                                                </div>
                                            </div>
                                            <Label>Instruções Corpo do Boleto</Label>
                                            <Field 
                                                id="instructions" 
                                                name="instructions" 
                                                as={Input}
                                                className="inputCustom" 
                                                style={{borderColor: `${errorOnSubmit && errors.instructions ? "red" : "rgba(194, 194, 194, 0.2)"}`}} 
                                            />
                                        </Form>
                                    </fieldset>
                                </FormContainer>
                            </div>
                            <Form>
                                <ButtonContainer className="row">
                                    <div className="col-12 col-lg-4">
                                    {
                                        errorOnSubmit && client.buyerIdAdquirente === "" 
                                        ? toastUpdate("btnSubmit","warning",3000,"Selecione um cliente" )
                                        : null
                                    }
                                    {(notifysFieldsForm(errors, errorOnSubmit))}
                                    
                                        {
                                            errorInReturnApi ? 
                                                <ErrorMessage>
                                                    Falha ao gerar boleto
                                                </ErrorMessage> : null
                                        }
                                        <Button 
                                            type="submit"
                                            onClick={() => {
                                                searchForErrors(errors);
                                                toastCreate("btnSubmit", "info", 2000, "Processando")
                                            }}
                                        >
                                            Gerar boleto
                                        </Button>
                                    </div>
                                </ButtonContainer>
                            </Form>
                        </>
                    )
                }}
            </Formik>
        </Main>
    )
}

export default PayOrderComplete;